import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const reviews = [{
  text: 'Mon fils de 7 ans a construit son premier robot en 20 minutes et depuis, il n’a plus jamais demandé la tablette. Le meilleur achat que j’ai fait depuis que je suis parent.',
  name: 'Jessica M.',
  meta: 'Maman de 2 enfants · Texas, États-Unis',
  letter: 'J',
  color: 'bg-brand',
  textTone: 'text-white',
  tone: 'bg-brand-light'
}, {
  text: 'Au début, j’étais sceptique — « encore un produit numérique » — mais les guides sont si clairs que même moi j’ai réussi à les suivre. Ma fille en est obsédée.',
  name: 'Sarah K.',
  meta: 'Maman de 3 enfants · Londres, Royaume-Uni',
  letter: 'S',
  color: 'bg-mint',
  textTone: 'text-ink',
  tone: 'bg-mint-light'
}, {
  text: 'Maintenant, on fait un projet chaque samedi matin. Mon fils appelle ça « le jour des robots ». Il en a appris plus sur l’ingénierie en deux mois qu’en une année scolaire entière.',
  name: 'Michael R.',
  meta: 'Papa d’un enfant · Sydney, Australie',
  letter: 'M',
  color: 'bg-sky',
  textTone: 'text-ink',
  tone: 'bg-sky-light'
}, {
  text: 'Le suivi de progression offert est une idée géniale. Mes enfants font la course à celui qui termine le plus de projets. Les disputes pour les écrans ont presque disparu.',
  name: 'Rachel T.',
  meta: 'Maman de 4 enfants · Toronto, Canada',
  letter: 'R',
  color: 'bg-sunshine',
  textTone: 'text-ink',
  tone: 'bg-sunshine-light'
}, {
  text: 'Je l’ai téléchargé vendredi soir, j’ai imprimé le guide rapide et avant le coucher, nous avions un robot qui fonctionnait. Ma fille de 5 ans était si fière. Ça vaut chaque centime.',
  name: 'Laura B.',
  meta: 'Maman de 2 enfants · Madrid, Espagne',
  letter: 'L',
  color: 'bg-coral',
  textTone: 'text-ink',
  tone: 'bg-coral-light'
}];
function Stars() {
  return <div className="flex text-amber-400" aria-hidden="true" data-id="element-181" data-mp="1xiirqu67zghn">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-182" data-mp="1sk7juozhjg22" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-183" data-mp="1ojfa7umpb959">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-184" data-mp="1jh6dcn6pjmxv">
        <SectionHeading eyebrow="Ce que disent les parents" title={<>De vraies familles. De vrais résultats.</>} subtitle="Plus de 2 000 familles utilisent déjà MakerLab pour éloigner leurs enfants des écrans et construire quelque chose de concret. Voici ce qu’elles en disent." data-id="element-185" data-mp="1jkkjm6ihsgal" />

        <div className="mt-8 flex items-center justify-center gap-3" data-id="element-186" data-mp="10rzzbdguzjie">
          <Stars data-id="element-187" data-mp="10px2a9hagq46" />
          <p className="text-sm font-semibold text-ink" data-id="element-188" data-mp="vsdpzf45inev">
            Plus de 2 000 familles — note moyenne de 4,9 sur 5
          </p>
        </div>

        <div className="mt-12 columns-1 gap-6 sm:columns-2 lg:columns-3 [&>*]:mb-6" data-id="element-189" data-mp="qu2fr39y2aw4">
          {reviews.map((r, i) => <motion.figure key={r.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.08
        }} className={`break-inside-avoid rounded-3xl border border-ink/10 p-6 ${r.tone}`} data-id="element-190" data-mp="32j06utwhr5b4" data-mpi={i}>
              <Stars data-id="element-191" data-mp="2sqb18fnmglnp" />
              <blockquote className="mt-3 text-sm leading-relaxed text-ink/80" data-id="element-192" data-mp="2sozviaam93ty">
                « {r.text} »
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3" data-id="element-193" data-mp="2106fodo4lskw">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold ${r.color} ${r.textTone}`} data-id="element-194" data-mp="20xu2sex868ep">
                  {r.letter}
                </span>
                <span data-id="element-195" data-mp="1gy27t24fdi2m">
                  <span className="block text-sm font-bold text-ink" data-id="element-196" data-mp="1gylh5ug0ey51">
                    {r.name}
                  </span>
                  <span className="block text-xs text-ink/50" data-id="element-197" data-mp="1vo9giq4mrmq4">{r.meta}</span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}